import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@bpinternal/ui-kit-next'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { DateTime } from 'luxon'
import { Link } from '~/elements'
import { listWorkspaceIntegrationsQueryOptions } from '~/queries'

export const Route = createFileRoute('/workspaces/$workspaceId/integrations/$integrationId/versions')({
  component: () => {
    const { workspaceId, integrationId } = Route.useParams()
    const workspaceIntegrations = useSuspenseQuery(listWorkspaceIntegrationsQueryOptions({ workspaceId })).data
    const integration = workspaceIntegrations.find((i) => i.id === integrationId)
    if (!integration) {
      // Should not happend
      return <p>Integration not found</p>
    }
    const integrationVersions = workspaceIntegrations.filter((i) => i.name === integration.name)

    return (
      <div className="flex flex-col gap-2">
        <h2 className="font-medium">Versions History</h2>
        <Table>
          <TableHeader>
            <TableRow className="text-gray-11">
              <TableHead className="w-4/5 font-medium">Version</TableHead>
              <TableHead className="font-medium">Published</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {integrationVersions.map((i) => (
              <TableRow key={i.id}>
                <TableCell>
                  <Link
                    to="/workspaces/$workspaceId/integrations/$integrationId"
                    params={{ workspaceId, integrationId: i.id }}
                  >
                    {i.version}
                  </Link>
                </TableCell>
                <TableCell>{DateTime.fromISO(i.createdAt).toRelative()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    )
  },
})
